import { object, string, InferType } from 'yup'

const schema = object({
  email: string().email('Email is incomplete').required('Email is required'),
}).defined()

export type Values = InferType<typeof schema>

export const useForm = (email?: string) => {
  const initialValues: Values = {
    email: email ?? '',
  }
  return { initialValues, schema } as const
}
